export const ACCEPTED_PHOTO_TYPES = '.jpg, .jpeg, .png, .gif, .tiff, .tif, .webp, .heic, .heif';
export const ACCEPTED_DOCUMENT_TYPES = '.pdf';
export const ACCEPTED_VIDEO_TYPES = '.mp4, .avi, .mov, .mpg, .mpeg, .wmv, .mkv, .m4v, .mts, .m2ts';
export const ACCEPTED_AUDIO_TYPES = '.mp3, .m4a, .wma, .ra, .mka, .ac3, .aac, .ogg, .flac, .wav, .amr';
export const FILES_TO_PROCESS_COUNT = 10;
export const DEFAULT_ORIENTATION = 1;
export const SKIP_THUMBNAILS_FOR_TYPES = ['.tiff', '.pdf', '.heic', '.heif'];
export const DEFAULT_MAX_FILE_SIZE_MB = 256;
export const DEFAULT_MAX_FILE_SIZE_MB_HUMAN = '256MB';
export const DEFAULT_MAX_DOCUMENT_SIZE_MB = 512;
export const DEFAULT_MAX_VIDEO_SIZE_MB = 5000;
export const DEFAULT_MAX_VIDEO_SIZE_HUMAN = '5GB';

export const UPLOAD_ERRORS = {
  generic: 'Something Went Wrong',
  invalidFileType: 'Type Not Supported',
  outOfStorage: 'Storage Full',
  fileTooLarge: 'File Too Big',
  duplicateFile: 'Duplicate File'
}

//todo: persist to settings
export const UPLOAD_DUPLICATES_LOCAL_STORAGE_KEY = 'upload-prevent-duplicates';
